<div class="container-fluid">
	<div class="row">
		<div class="col-md-6">
			<h3 class="prealert-title text-center text-md-left">
				Añade los datos de tu compra <br>
				y realiza tu primera prealerta</h3>
			<p *ngIf="user.name">
				Hola, <label class="text-danger">{{user.name | uppercase}} {{user.lastname | uppercase}}</label>, puedes
				realizar tu prealerta de Inbox. ¿No eres {{user.name | uppercase}}?<br>
				<label class="text-danger" (click)="openModal(content)">Inicia sesión</label> con su usuario
			</p>
		</div>
	</div>
	<form action="" [formGroup]="pageForm">
		<div class="row">
			<div class="form-group col-12 col-md-3">
				<input class="form-control" type="text" placeholder="Número de tracking" formControlName="track_number">
				<div *ngIf="submitted && f.track_number.errors?.required" class="invalid-feedback d-block">
					Campo requerido
				</div>
			</div>
			<div class="form-group col-12 col-md-3">
				<input class="form-control" type="text" placeholder="Descripción del articulo" formControlName="description">
				<div *ngIf="submitted && f.description.errors?.required" class="invalid-feedback d-block">
					Campo requerido
				</div>
			</div>
			<div class="form-group col-12 col-md-3">
				<input class="form-control" type="text" placeholder="Peso LB/Vol" formControlName="weight">
				<div *ngIf="submitted && f.weight.errors?.required" class="invalid-feedback d-block">
					Campo requerido
				</div>
			</div>
			<div class="form-group text-center text-md-left col-12 col-md-3">
				<button type="submit" class="btn btn-primary rounded button" (click)="open(content)">
					Realizar Prealerta
				</button>
			</div>
		</div>
	</form>

	<!-- Modal -->
	<ng-template #content let-modal>
		<div class="modal-header">
			<h3 class="modal-title text-black-50" id="modal-basic-title">
				Inicia Sesión <br>
				<small>Inicia sesión con tu cuenta <strong class="text-danger">INBOX</strong> para realizar tu
					prealerta.</small>
			</h3>
			<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="loginForm">
				<div class="form-group">
					<input class="form-control" type="email" name="email" id="email" formControlName="email" placeholder="Email">
					<div *ngIf="submitted && l.email.errors?.required" class="invalid-feedback d-block">
						Campo requerido
					</div>
					<div *ngIf="submitted && l.email.errors?.email" class="invalid-feedback d-block">
						Ingrese un email válido
					</div>
				</div>
				<div class="form-group">
					<input class="form-control" type="password" name="password" id="password" formControlName="password"
						placeholder="Contraseña">
					<div *ngIf="submitted && l.password.errors?.required" class="invalid-feedback d-block">
						Campo requerido
					</div>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="modal.close('Save click')">Login</button>
		</div>
	</ng-template>
	<hr>

	<pre>{{ closeResult }}</pre>
</div>